<template>
  <el-drawer :withHeader="false" :visible.sync="open" direction="rtl" :before-close="handleClose" size="666px">
    <!-- <div class="close">
      收起
    </div> -->
    <div class="drawer-header">
      <div style="padding-top:20px;display: flex;">
        <div class="start-label" />
        <span class="text">查看知识库详情</span>
      </div>
    </div>
    <div class="info">
      <div class="triangle"></div>
      <div class="info-conten">
        <span style="font-size:14px;font-weight:bold">知识类型: </span>
        <span style="margin-left:10px;font-size:14px;color:#E8B23D;font-weight:bold">{{form.categoryName}}</span><br />
        <!-- <span>启用状态：</span>
        <span style="margin-left:10px" :class="{enable: form.state==1, forbidden: form.state!=1}">{{form.stateName}}</span> -->
      </div>
    </div>

    <div style="margin:10px 20px 0;">
      <div class="badge">知识基础信息</div>
      <div style="margin-top:10px">
        <el-form label-width="110px">
          <el-form-item label="知识编码:" prop="no">
            <span class="value">{{form.no}}</span>
          </el-form-item>
          <el-form-item label="知识名称:" prop="name">
            <span class="value">{{form.name}}</span>
          </el-form-item>
          <el-form-item label="创建人:" prop="createdUserName">
            <span class="value">{{form.createdUserName}}</span>
          </el-form-item>
          <el-form-item label="创建时间:" prop="createdTime">
            <span class="value">{{parseTime(new Date(form.createdTime))}}</span>
          </el-form-item>
          <el-form-item label="知识内容:">
            <div class="value">{{form.content}}</div>
          </el-form-item>
          <el-form-item label="备注:">
            <div class="value">{{form.remark}}</div>
          </el-form-item>
          <el-form-item label="附件:">
            <div v-for="item in form.fileInfos" :key="item.id" class="value color-blue pointer" v-preventReClick
            @click="openImageViewer(item)">{{item.name}}</div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />

  </el-drawer>
</template>

<script>
import { GetKnowBaseById } from '@/api';
import GetDataMixin from '@/mixin/getData-mixin.js'
import ElImageViewer from '@/components/elImageViewer'

export default {
  name: 'user-info',
  mixins: [GetDataMixin],
  components: {
    ElImageViewer
  },
  data () {
    return {
      open: false,
      form: {},

      fileId: 0,
      fileName: '',
      openViewer: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default () {
        return false
      }
    },
    id: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  watch: {
    'show' (val, oldVal) {
      this.open = val

      if (this.open) {
        this.getInfo()
      }
    },
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
    },
    getInfo () {
      GetKnowBaseById({ id: this.id }).then(res => {
        this.resetForm()
        this.form = res.returnData
      })
    },
    resetForm () {
      this.form = {
        orgCode :sessionStorage.getItem('orgId')
      }
    },


    // 上传附件
    openImageViewer (e) {
      this.openViewer = true;
      this.fileId = e.id
      this.fileName = e.name
    },
    closeImageViewer () {
      this.openViewer = false;
    },
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content {
  line-height: 20px !important;
  color: #606166;
  font-weight: 400;
}
/deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
</style>